module.exports = __webpack_public_path__ + "media/NoRecord.a1031cb0.mp3";